import clsx from 'clsx'
import PixelArrow from '../svg/icon/PixelArrow'

type Props = {
	direction?: 'left' | 'right'
	theme?: string | null | undefined
	className?: string
}

export default function ArrowButton({
	direction = 'left',
	theme = 'light',
	className,
	...props
}: Props & JSX.IntrinsicAttributes & React.ButtonHTMLAttributes<HTMLButtonElement>) {
	return (
		<button
			className={clsx(
				'flex items-center justify-center h-12 w-12 md:h-24 md:w-24  transition-colors duration-300',
				theme === 'light'
					? 'bg-white hover:bg-white-frosted-shade border-b border-white-frosted'
					: 'bg-white-frosted hover:bg-white-frosted-shade',
				className
			)}
			{...props}
		>
			<PixelArrow
				className={clsx(
					'text-blue h-4 md:h-5 w-fit',
					{ 'rotate-180': direction === 'left' },
					className
				)}
			/>
		</button>
	)
}
